import React, { useState } from 'react';

function rowText(row, columns) {
  // The underlying value counts even when a column renders itself: a table whose
  // columns all pass a `render` (a score bar, a badge, a relative time) would
  // otherwise have empty search text, so the filter would hide every row the
  // moment anything was typed.
  return columns
    .map((c) => {
      const v = row[c.key];
      return typeof v === 'string' || typeof v === 'number' ? String(v) : '';
    })
    .join(' ')
    .toLowerCase();
}

function DataTable({
  columns = [], rows = [], rowKey = 'id',
  searchable = false, searchPlaceholder = 'Search…',
  emptyText = 'No records', loading = false, className = '',
}) {
  const [query, setQuery] = useState('');

  const q = query.trim().toLowerCase();
  const visible = q
    ? rows.filter((r) => rowText(r, columns).includes(q))
    : rows;

  return (
    <div className={className}>
      {searchable && (
        <div className="filter-bar">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={searchPlaceholder}
            spellCheck={false}
            autoComplete="off"
          />
        </div>
      )}
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} style={c.width ? { width: c.width } : undefined}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visible.map((row, ri) => (
              <tr key={row[rowKey] ?? ri} onClick={row.onClick} style={row.onClick ? { cursor: 'pointer' } : undefined}>
                {columns.map((c) => (
                  <td key={c.key}>
                    {typeof c.render === 'function' ? c.render(row[ c.key], row, ri) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
            {loading && visible.length === 0 && (
              <tr><td colSpan={columns.length} className="empty">Loading…</td></tr>
            )}
            {!loading && visible.length === 0 && (
              <tr><td colSpan={columns.length} className="empty">{emptyText}</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;
